import React from 'react';
import { PortfolioData } from '../types/portfolio';

interface CertificationsProps {
  data: PortfolioData;
}

const Certifications: React.FC<CertificationsProps> = ({ data }) => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="mb-16">
          <h2 className="text-4xl font-manrope font-bold text-navy mb-4">
            Certifications
          </h2>
          <div className="h-1 w-16 bg-teal rounded-full"></div>
        </div>

        {/* Certifications Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {data.certifications.map((cert, idx) => (
            <div
              key={cert.id}
              className="group bg-gradient-to-br from-navy to-deep-blue p-8 rounded-2xl border border-gold/20 hover:border-gold transition-all duration-300 hover:shadow-xl text-white animate-fadeInUp"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              {/* Icon */}
              <div className="mb-6">
                <svg className="w-12 h-12 text-gold" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 3.062v6.218c0 1.3-.756 2.423-1.848 2.97l-6.368 3.322a3.066 3.066 0 01-2.745 0l-6.368-3.322C2.756 15.7 2 14.577 2 13.277V7.059a3.066 3.066 0 012.267-3.062zm2.461 4.491a.75.75 0 10-1.06-1.061L7.07 9.75l3.656-3.656a.75.75 0 101.06 1.061L8.13 10.81l3.656 3.656a.75.75 0 10-1.06 1.061L7.13 11.871l-2.379 2.379a.75.75 0 10 1.06 1.061L8.19 12.93l2.379 2.379a.75.75 0 101.06-1.061L9.25 11.871l3.656-3.656a.75.75 0 10-1.06-1.061L8.19 10.81l-3.656-3.656z" clipRule="evenodd"></path>
                </svg>
              </div>

              {/* Title */}
              <h3 className="text-xl font-manrope font-bold mb-2 group-hover:text-gold transition-colors">
                {cert.title}
              </h3>

              {/* Accent Line */}
              <div className="h-0.5 w-8 bg-gradient-to-r from-gold to-teal rounded-full group-hover:w-12 transition-all duration-300"></div>
            </div>
          ))}
        </div>

        {/* Supporting Text */}
        <div className="mt-12 p-8 bg-gray-50 rounded-xl border border-gray-200 text-center">
          <p className="text-slate text-base leading-relaxed">
            Certifications demonstrate commitment to continuous learning and validation of cloud and technology fundamentals, supporting broader technical understanding in modern business environments.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
